import React from "react";
import { noItx } from "../translationItx/itx";

export default function PdfViewer(props: { url: string | undefined }) {
  var { url } = props;

  url = noItx("https://www.mdt.de/fileadmin/user_upload/user_upload/download/MDT_THB_AKH_03_Heizungsaktor_V12.pdf");

  return (
    <object data={url} type="application/pdf" width="100%" height="100%">
      <iframe src={url} width="100%" height="100%" style={{ border: "none" }}></iframe>
    </object>
  );
}
